/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-11-25                                                        *
 ******************************************************************************/

import { ref, reactive } from '@vue/composition-api'

export default function () {
    function formatCurrency(value,code) {
        const number = parseFloat(value);
        if(isNaN(number)){
            return '';
        }
        let currencyFormatter;
        if(code){
            currencyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: code });
        }else{
            currencyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD'});

        }
        return currencyFormatter.format(number)
    }
    return {
        formatCurrency
    }
}
